import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { AV_TAB, NETWORK_TAB, PROFILE_TAB, INTEGRATIONS_TAB } from 'constants/SettingsModal';
import SettingsModalNavListItem from './SettingsModalNavListItem';

class SettingsModalNav extends React.PureComponent {
  render() {
    const { showAdvancedSettings, showNotificationSettings } = this.props;

    return (
      <ul>
        <SettingsModalNavListItem
          tabName={AV_TAB}
          handleChangeTab={this.props.handleChangeTab}
          isActiveTab={this.props.visibleTab === AV_TAB}
        >
          <FormattedMessage id="settings.modal.nav.av" defaultMessage="Audio/Video" />
        </SettingsModalNavListItem>
        {showNotificationSettings && (
          <SettingsModalNavListItem
            tabName={INTEGRATIONS_TAB}
            handleChangeTab={this.props.handleChangeTab}
            isActiveTab={this.props.visibleTab === INTEGRATIONS_TAB}
          >
            <FormattedMessage id="settings.modal.nav.integrations" defaultMessage="Integrations" />
          </SettingsModalNavListItem>
        )}
        {showAdvancedSettings && (
          <SettingsModalNavListItem
            tabName={NETWORK_TAB}
            handleChangeTab={this.props.handleChangeTab}
            isActiveTab={this.props.visibleTab === NETWORK_TAB}
          >
            <FormattedMessage id="settings.modal.nav.network" defaultMessage="Network" />
          </SettingsModalNavListItem>
        )}
        <SettingsModalNavListItem
          tabName={PROFILE_TAB}
          handleChangeTab={this.props.handleChangeTab}
          isActiveTab={this.props.visibleTab === PROFILE_TAB}
        >
          <FormattedMessage id="settings.modal.nav.profile" defaultMessage="My Profile" />
        </SettingsModalNavListItem>
      </ul>
    );
  }
}

SettingsModalNav.propTypes = {
  visibleTab: PT.string.isRequired,
  handleChangeTab: PT.func.isRequired,
  showNotificationSettings: PT.bool,
  showAdvancedSettings: PT.bool
};

export default injectIntl(SettingsModalNav);
